import { useSyncExternalStore } from 'react'

import type { SavedBucketDto } from 'store/types'

type Listener = () => void

const listeners = new Set<Listener>()
let savedBucketsState: SavedBucketDto[] = []

const areSavedBucketsEqual = (left: SavedBucketDto[], right: SavedBucketDto[]): boolean =>
  left.length === right.length &&
  left.every(
    (bucket, index) =>
      bucket.bucket === right[index]?.bucket && bucket.testType === right[index]?.testType,
  )

const emitChange = () => {
  listeners.forEach((listener) => listener())
}

const subscribe = (listener: Listener) => {
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
  }
}

const getSnapshot = () => savedBucketsState

export const initializeLabSavedBuckets = (savedBuckets: SavedBucketDto[] = []) => {
  if (areSavedBucketsEqual(savedBucketsState, savedBuckets)) {
    return
  }

  savedBucketsState = savedBuckets
  emitChange()
}

export const setLabSavedBucketsState = (savedBuckets: SavedBucketDto[] = []) => {
  if (areSavedBucketsEqual(savedBucketsState, savedBuckets)) {
    return
  }

  savedBucketsState = savedBuckets
  emitChange()
}

export const useLabSavedBuckets = (): SavedBucketDto[] =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
